import React from 'react';
import {
  Container,
  ContainerPadding,
  ContainerGutter,
  ContainerWrap,
  CTA,
  styled,
  Text,
  TextAppearance,
} from '@volkswagen-onehub/components-core';
import { useIsComerciales } from 'src/feature-app/hooks';

const CTAlinkWhithe = styled.span`
  a {
    color: #ffffff;
  }
`;

interface legalesFormatoLayerProps {
  noPadding?: boolean;
  title?: boolean;
  showBasesLegales?: boolean;
  promocion?: boolean;
  hrefBasesLegales?: string;
}
const Wrapper = styled.div<legalesFormatoLayerProps>`
  padding-top: ${(props) => (props.noPadding ? null : '72px')};
  padding-bottom: ${(props) => (props.noPadding ? null : '52px')};
`;

export const LegalesFormatoLayer = (props: legalesFormatoLayerProps) => {
  const isComerciales = useIsComerciales();

  return isComerciales ? <LegalesFormatoLayerComerciales {...props} /> : <LegalesFormatoLayerTurismos {...props} />;
};
const LegalesFormatoLayerTurismos = (props: legalesFormatoLayerProps) => {
  return (
    <Wrapper noPadding={props.noPadding}>
      <Container gutter={ContainerGutter.static300} wrap={ContainerWrap.always}>
        {props.title ? (
          <Text bold staticSize appearance={TextAppearance.copy0200}>
            Texto legal de Volkswagen
          </Text>
        ) : null}

        <Text staticSize appearance={TextAppearance.copy0150}>
          {!props.promocion ? (
            <>
              Te informamos que el responsable del tratamiento de tus datos es la compañía VOLKSWAGEN GROUP ESPAÑA
              DISTRIBUCION, S.A.U., con la finalidad de atender tus consultas y solicitudes, realizar un control de
              calidad sobre los productos y servicios solicitados, realizar encuestas de opinión y estudios de mercado
              con fines estadísticos. En caso que nos hayas dado tu consentimiento, para las finalidades descritas en
              los consentimientos adicionales.
            </>
          ) : (
            <>
              Te informamos que el responsable del tratamiento de tus datos es la compañía VOLKSWAGEN GROUP ESPAÑA
              DISTRIBUCION, S.A.U., con la finalidad de gestionar tu participación en la Promoción y, en el caso que lo
              consientas, para los fines comerciales y/o perfilado según lo indicado en el propio consentimiento.
            </>
          )}
        </Text>
        <Text staticSize appearance={TextAppearance.copy0150}>
          {!props.promocion ? (
            <>
              Te informamos que tienes derecho a retirar tu consentimiento en cualquier momento, así como a oponerte al
              tratamiento, limitar el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a la
              portabilidad, mediante petición escrita a{' '}
            </>
          ) : (
            <>
              Te informamos que tienes derecho a retirar tu consentimiento en cualquier momento, así como a oponerte al
              tratamiento, limitar el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a la
              portabilidad, enviando un correo electrónico a{' '}
            </>
          )}
          <CTAlinkWhithe>
            <CTA tag="a" href="mailto:atencioncliente@volkswagen.es" target="_blank" emphasis="tertiary">
              <b>atencioncliente@volkswagen.es</b>
            </CTA>
          </CTAlinkWhithe>
          .
        </Text>
        <Text staticSize appearance={TextAppearance.copy0150}>
          Puedes consultar con mayor detalle la información adicional sobre la política de privacidad{' '}
          <CTAlinkWhithe>
            <CTA
              tag="a"
              href="https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html"
              target="_blank"
              emphasis="tertiary"
            >
              <b>aquí</b>
            </CTA>
          </CTAlinkWhithe>
          .
        </Text>
        {props.showBasesLegales ? (
          <Text staticSize appearance={TextAppearance.copy0150}>
            Consulta las{' '}
            <CTAlinkWhithe>
              <CTA
                tag="a"
                href={
                  props.hrefBasesLegales
                    ? props.hrefBasesLegales
                    : 'https://crm.volkswagen.es/cms/2021/Volkswagen_Dia_de_la_madre_2021_BBLL.pdf'
                }
                target="_blank"
                emphasis="tertiary"
              >
                <b>Bases Legales</b>
              </CTA>
            </CTAlinkWhithe>{' '}
            de la promoción.
          </Text>
        ) : null}
      </Container>
    </Wrapper>
  );
};
const LegalesFormatoLayerComerciales = (props: legalesFormatoLayerProps) => {
  return (
    <Wrapper noPadding={props.noPadding}>
      <Container gutter={ContainerGutter.static300} wrap={ContainerWrap.always}>
        {props.title ? (
          <Text bold staticSize appearance={TextAppearance.copy0200}>
            Texto legal de Volkswagen
          </Text>
        ) : null}

        <Text staticSize appearance={TextAppearance.copy0150}>
          Vamos a utilizar tus datos para el mantenimiento, desarrollo y/o control de nuestra relación comercial;
          atender a tus consultas y solicitudes; realizar un control de calidad sobre los productos y servicios por los
          que te hayas interesado; realización de encuestas de opinión y estudios de mercado con fines estadísticos.
        </Text>
        <Text staticSize appearance={TextAppearance.copy0150}>
          Tus datos se enviarán al concesionario que hayas seleccionado, si has seleccionado alguno, para la prestación
          del servicio solicitado o dar respuesta a la petición que hayas realizado (por ejemplo la prueba de un
          vehículo o envío de un presupuesto solicitado).
        </Text>
        <Text staticSize appearance={TextAppearance.copy0150}>
          Tienes derecho a retirar tus consentimientos en cualquier momento, así como oponerte al tratamiento, limitar
          el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a portabilidad, mediante el envío de un
          mail a{' '}
          <CTAlinkWhithe>
            <CTA tag="a" href="mailto:atencioncliente@volkswagen-comerciales.es" target="_blank" emphasis="tertiary">
              <b>atencioncliente@volkswagen-comerciales.es</b>
            </CTA>
          </CTAlinkWhithe>
          .
        </Text>
        <Text staticSize appearance={TextAppearance.copy0150}>
          Puedes consultar con mayor detalle la Información adicional sobre Protección de Datos{' '}
          <CTAlinkWhithe>
            <CTA
              tag="a"
              href="https://www.volkswagencomerciales.es/v2/pdf/Formulario_RGPD_certificacion_Capa2_2019_v2.pdf"
              target="_blank"
              emphasis="tertiary"
            >
              <b>aquí</b>
            </CTA>
          </CTAlinkWhithe>
          .
        </Text>
      </Container>
    </Wrapper>
  );
};

export const LegalesFastStart = (props: legalesFormatoLayerProps) => {
  return (
    <Wrapper noPadding={props.noPadding}>
      <Container gutter={ContainerGutter.static300} wrap={ContainerWrap.always}>
        {props.title ? (
          <Text bold staticSize appearance={TextAppearance.copy0200}>
            Texto legal de Volkswagen
          </Text>
        ) : null}
        <Text staticSize appearance={TextAppearance.copy0150}>
            Te informamos que el responsable del tratamiento de tus datos es la compañía VOLKSWAGEN GROUP ESPAÑA
            DISTRIBUCION, S.A.U., con la finalidad de atender tus consultas y solicitudes, realizar un control de calidad sobre los productos y servicios solicitados, realizar encuestas de opinión y estudios de mercado con fines estadísticos y gestionar tu participación gratuita en la Promoción Driving Experience Grandvalira comunicada durante el proceso de cita previa.
        </Text>
        <Text staticSize appearance={TextAppearance.copy0150}>
          Para más información sobre el tratamiento de los datos pulsa{' '}
          <CTAlinkWhithe>
            <CTA
              tag="a"
              href="https://crm.volkswagen.es/cms/2022/Bases%20legales%20Vw%20driving%20experience.pdf"
              target="_blank"
              emphasis="tertiary"
            >
              <b>aquí</b>
            </CTA>
          </CTAlinkWhithe>
          .
        </Text>
      </Container>
    </Wrapper>
  );
}

export const LegalesJarama = (props: legalesFormatoLayerProps) => {
  return (
    <Wrapper noPadding={props.noPadding}>
      <Container gutter={ContainerGutter.static300} wrap={ContainerWrap.always}>
        {props.title ? (
          <Text bold staticSize appearance={TextAppearance.copy0200}>
            Texto legal de Volkswagen
          </Text>
        ) : null}
        <Text staticSize appearance={TextAppearance.copy0150}>
            Te informamos que el responsable del tratamiento de tus datos es la compañía VOLKSWAGEN GROUP ESPAÑA
            DISTRIBUCION, S.A.U., con la finalidad de atender tus consultas y solicitudes, realizar un control de calidad sobre los productos y servicios solicitados, realizar encuestas de opinión y estudios de mercado con fines estadísticos y gestionar tu participación gratuita en la Promoción Driving Experience Jarama comunicada durante el proceso de cita previa.
        </Text>
        <Text staticSize appearance={TextAppearance.copy0150}>
          Para más información sobre el tratamiento de los datos pulsa{' '}
          <CTAlinkWhithe>
            <CTA
              tag="a"
              href="https://crm.volkswagen.es/pdf/Bases%20legales%20Vw%20drive%20experience_Jarama.pdf"
              target="_blank"
              emphasis="tertiary"
            >
              <b>aquí</b>
            </CTA>
          </CTAlinkWhithe>
          .
        </Text>
      </Container>
    </Wrapper>
  );
}

